export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5117.7392c38b.jpg";